export enum RESULT_PAYMENT {
  LOADING = 'LOADING',
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  CANCELLED = 'CANCELLED',
}

export enum SERVICE_TYPE {
  TICKETS = 'TICKETS',
  EXCURSIONS = 'EXCURSION_ORDERS',
  FLIGHTS = 'FLIGHT_APPEALS',
  BEKET = 'BUS_TICKET_ORDER',
  TOURS = 'TOURS',
  UMRA = 'UMRA',
  KYRGYZSTAN = 'KYRGYZSTAN_ORDERS',
  INSURANCE = 'INSURANCE',
  ESIM = 'ESIM',
}

export interface ICheckPay {
  status: RESULT_PAYMENT
  service_type: SERVICE_TYPE
}

export const PaymentStatusLoading = [
  RESULT_PAYMENT.LOADING,
  RESULT_PAYMENT.CREATED,
  RESULT_PAYMENT.IN_PROGRESS,
]

export type CertificateStatus = 'PENDING' | 'SUCCESS' | 'FAILED'
